import { Modal } from 'ui'
import { EditCompanyGroupMemberForm } from './EditCompanyGroupMemberForm'
import { useCompanyMembersContext } from '../../../context/CompanyMembersProvider'
import { EditSingleCompanyMemberForm } from './EditSingleCompanyMemberForm'

export const EditMemberMain = ({ onClose }: { onClose: () => void }) => {
  const {
    state: { isInCompanyGroup },
  } = useCompanyMembersContext()

  return (
    <Modal title="Manage access" open onClose={onClose}>
      {isInCompanyGroup ? (
        <EditCompanyGroupMemberForm />
      ) : (
        <EditSingleCompanyMemberForm />
      )}
    </Modal>
  )
}
